import React, { useState, useEffect, useContext } from "react";
import LangContext from "../utils/LangContext";
import { langAPI } from "../api/langAPI";
import ImageSlider from "../utils/ImageSlider";

export default function Soundlibrary() {
  const [state, setState] = useState([]);
  const { lang } = useContext(LangContext);

  useEffect(() => {
    langAPI(lang).then(setState);
  }, [lang]);

  return state.map((item, idx) => <RenderSoundlibrary key={idx} data={item} />);
}

const SliderData = [
  {
    image: require("../images/project_2/Upload-Sound Library1.png"),
  },
  {
    image: require("../images/project_2/Upload-Sound Library2.png"),
  },
  {
    image: require("../images/project_2/Upload-Sound Library3.png"),
  },
];

const RenderSoundlibrary = ({ data }) => {
  return (
    <>
      <div className="mt-36">
        <h1 className="md:px-40 px-4">Soundlibrary</h1>
        <p className="md:px-40 px-4">{data.body.sound}</p>
      </div>
      <ImageSlider slides={SliderData} />
    </>
  );
};
